<template>
  <div style="display: flex;flex-wrap: wrap">
    <el-cascader
      :show-all-levels="false"
      clearable
      filterable
      @change="sures"
      v-model="selectinfo"
      :options="departmentlist"
      :placeholder="pleasett"
      :props="{ checkStrictly: true, emitPath: false,expandTrigger: 'hover',multiple: type=='multi'?true:false  }"
      clearable></el-cascader>
  </div>
</template>

<script>
import u from "../../../assets/js/util";

export default {
  props: ["type", "values"],
  name: "select_department",
  data() {
    return {
      pleasett: "请选择",
      department: [],
      selectinfo: [],
      selectlist: [],//选中数组
      corporinfo: {},
      departmentlist: [{
        "id": "",
        "label": "",
        "children": []
      }]
    }
  },
  mounted() {
    this.reloaddata()
    if (this.values) {
      setTimeout(() => {
        if (this.type == "multi") {
          this.selectinfo = this.values
        } else {
          if (this.values[0]) {
            this.selectinfo = this.values[0]
            this.pleasett = this.values[0].name
            this.$forceUpdate()
          }
        }
      })
    }
  },
  methods: {
    sures(e) {
      if (this.type == "multi") {
        this.$emit("sure", e)
      } else {
        this.$emit("sure", [e])
      }
    },
    async reloaddata() {
      var info = await u.post("users", "get_corporationinfo")
      if (info !== false) {
        this.corporinfo = info
      }
      var department = await u.post("users", "getdepartment", {
        size: 999,
        table: "department",
        where: {grouid: userinfo.grouid}
      })
      this.department = department[0]
      this.departmentlist[0].id = info._id
      this.departmentlist[0].value = {id: info._id, name: info.name}
      this.departmentlist[0].label = info.name
      this.departmentlist[0].children = []
      var departmentlist = department[0]
      var de = []
      departmentlist.forEach((item) => {
        item.check = false
        for (var i = 0; i < this.selectlist.length; i ++) {
          if (item._id == this.selectlist[i].id) {
            item.check = true
          }
        }
        de.push(item)
      })
      this.departmentlist[0].children = this.recursionGenerateTree(this.corporinfo._id, de)
      this.$forceUpdate()
    },
    recursionGenerateTree(pid, arr) {
      let array = []
      arr.forEach(item => {
        if (item.father === pid) {
          var children = this.recursionGenerateTree(item._id, arr) // 接收子节点
          var item = {
            id: item._id,
            value: {id: item._id, name: item.name},
            label: item.name,
            children: children,
          }
          array.push(item)
        }
      })
      return array // 返回查找到的节点
    }
  }
}
</script>

<style scoped>

.poprs_box {
  width: 100%;
  height: 600px;
  display: flex;
  justify-content: space-around;
}

.box {
  border-radius: 5px;
  border: solid 1px #CCCCCC;
}


.el-dialog__body {
  padding: 0
}

/deep/ .el-input__inner::placeholder {
  color: rgba(0, 0, 0, 0.685) ;
}

</style>



// WEBPACK FOOTER //
// src/page/module/util/select_department.vue